import axios from 'axios'

const state = {
  canLoadMore: false,
  messageTemplates: {
    'customer': [],
    'professional': [],
    'beneat_professional': [],
    'sales_product_customer': [],
    'recruitment_customer': [],
    'recruitment_professional': [],
    'mari_customer': [],
    'mari_professional': []
  },
  manageMessageTemplates: null,
  messageTemplate: null,
  categories: []
}

const actions = {
  fetchMessageTemplates: async ({ commit, state }, params) => {
    commit('SET_CAN_LOAD_MORE', true)

    // ถ้าเป็นการ Load Template Message จาก MessageBox ให้เช็คว่ามี Data อยู่แล้วหรือยัง
    // if (!params.force_fetch_data && params.hasOwnProperty('fetch_from_settings') && params.customer_type && state.messageTemplates[`${params.customer_type}`] && state.messageTemplates[`${params.customer_type}`].length > 0) {
    //   return Promise.resolve(state.messageTemplates[params.customer_type])
    // }
    // if (!params.force_fetch_data && params.hasOwnProperty('fetch_from_settings') && params.customer_type && state.messageTemplates[`${params.customer_type}`] && state.messageTemplates[`${params.customer_type}`].length > 0) {
    //   console.log('yeah', state.messageTemplates[`${params.customer_type}`])
    //   // commit('SET_MANAGE_MESSAGE_TEMPLATES', state.messageTemplates[params.customer_type])
    //   return Promise.resolve(state.messageTemplates[params.customer_type])
    // }

    let customerType = params.customer_type
    if (customerType === 'professional_secondary') {
      // ให้ใช้ข้อมูลจากฝั่งผู้สมัครเหมือนกัน เนื่องจาก professional_secondary เป็น type สำรองของ professional
      customerType = 'professional'
    } else if (customerType === 'recruitment_professional_secondary') {
      // ให้ใช้ข้อมูลจากฝั่ง Recruit เหมือนกัน เนื่องจาก recruitment_professional_secondary เป็น type สำรองของ recruitment_professional
      customerType = 'recruitment_professional'
    }
    params.customer_type = customerType

    if (params.page === 0) {
      const paramsItem = {
        messageTemplates: [],
        customerType: customerType
      }
      commit('SET_MESSAGE_TEMPLATES', paramsItem)
    }

    const url = '/message-templates'
    const res = await axios.get(url, { params })
    const messageTemplates = res.data.message_templates
    if (res.status === 200 && messageTemplates.length) {
      if (params.hasOwnProperty('fetch_from_settings')) {
        params.page === 0 ? commit('SET_MANAGE_MESSAGE_TEMPLATES', messageTemplates) : commit('SET_MORE_MANAGE_MESSAGE_TEMPLATES', messageTemplates)
      } else {
        const paramsItem = {
          messageTemplates,
          customerType: params.customer_type
        }
        params.page === 0 ? commit('SET_MESSAGE_TEMPLATES', paramsItem) : commit('SET_MORE_MESSAGE_TEMPLATES', paramsItem)
      }
      return Promise.resolve(res.data)
    } else {
      commit('SET_CAN_LOAD_MORE', false)
      return Promise.reject(res.data.error)
    }
  },
  deleteImage: async ({ commit }, submitData) => {
    const url = `/message-templates/${submitData.id}/images`
    const res = await axios.delete(url, { data: { uuid: submitData.uuid } })
    console.log('res delete gallery', res)
  },
  fetchCategories: async ({ commit }) => {
    let { data } = await axios.get('/message-template-categories')
    commit('SET_CATEGORIES', data.categories)
  }
}

const mutations = {
  SET_CATEGORIES: (state, categories) => {
    state.categories = categories
  },
  SET_MANAGE_MESSAGE_TEMPLATES: (state, manageMessageTemplates) => {
    state.manageMessageTemplates = manageMessageTemplates
  },
  SET_MORE_MANAGE_MESSAGE_TEMPLATES: (state, manageMessageTemplates) => {
    state.manageMessageTemplates = [...state.manageMessageTemplates, ...manageMessageTemplates]
  },
  SET_MESSAGE_TEMPLATES: (state, { messageTemplates, customerType }) => {
    state.messageTemplates[customerType] = [...messageTemplates]
    state.messageTemplates[customerType] = [...state.messageTemplates[customerType]]
  },
  SET_MORE_MESSAGE_TEMPLATES: (state, { messageTemplates, customerType }) => {
    state.messageTemplates[customerType] = [...state.messageTemplates, ...messageTemplates]
  },
  UPDATE_MESSAGE_TEMPLATE: (state, messageTemplate) => {
    for (let key in state.manageMessageTemplates) {
      if (state.manageMessageTemplates[key].id === messageTemplate.id) {
        state.manageMessageTemplates[key] = messageTemplate
        break
      }
    }
    state.manageMessageTemplates = [...state.manageMessageTemplates]
  },
  SET_CAN_LOAD_MORE: (state, status) => {
    state.canLoadMore = status
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
